import Grid2 from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';

export const GuestContactFields = ({
  name,
  setName,
  surname,
  setSurname,
  email,
  setEmail,
  emailError,
  validateEmail,
  phone,
  setPhone,
}: any) => (
  <>
    <Grid2 size={{ xs: 12, sm: 6 }}>
      <TextField size="small" label="Imię" fullWidth value={name} onChange={(e) => setName(e.target.value)} required />
    </Grid2>
    <Grid2 size={{ xs: 12, sm: 6 }}>
      <TextField size="small" label="Nazwisko" fullWidth value={surname} onChange={(e) => setSurname(e.target.value)} required />
    </Grid2>
    <Grid2 size={{ xs: 12, sm: 6 }}>
      <TextField
        size="small"
        label="Email"
        type="email"
        fullWidth
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
          validateEmail(e.target.value);
        }}
        error={!!emailError}
        helperText={emailError}
        required
      />
    </Grid2>
    <Grid2 size={{ xs: 12, sm: 6 }}>
      <TextField
        size="small"
        label="Numer telefonu"
        type="tel"
        fullWidth
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        required
      />
    </Grid2>
  </>
);
